import { render } from "./StaxPaymentForm.vue?vue&type=template&id=31d1c0dc&scoped=true"
import script from "./StaxPaymentForm.vue?vue&type=script&lang=js"
export * from "./StaxPaymentForm.vue?vue&type=script&lang=js"

import "./StaxPaymentForm.vue?vue&type=style&index=0&id=31d1c0dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d1c0dc"]])

export default __exports__